export function makeFolderName(parent, child) {
    if (child !== "") {
        if (parent.endsWith("/") && child.startsWith("/")) {
            return parent + child.substring(1);
        }
        if (parent.endsWith("/") || child.startsWith("/")) {
            return parent + child;
        }
        return parent + "/" + child;
    }
    else {
        return "";
    }
}
export function removeLeadingSlash(path) {
    if (path.startsWith("/")) {
        return path.substring(1);
    }
    else {
        return path;
    }
}
export function addLeadingSlash(path) {
    if (!path.startsWith("/")) {
        return "/" + path;
    }
    else {
        return path;
    }
}
export function removeTrailingSlash(path) {
    if (path.endsWith("/")) {
        return path.substring(0, path.length - 1);
    }
    else {
        return path;
    }
}
export function addTrailingSlash(path) {
    if (!path.endsWith("/")) {
        return path + "/";
    }
    else {
        return path;
    }
}
export function splitPath(path, defaultRoot = "/") {
    if (!path) {
        return undefined;
    }
    path = addLeadingSlash(path);
    const brokenByDot = path.split(".");
    let extension;
    if (brokenByDot.length === 1) {
        extension = "";
    }
    else {
        extension = "." + brokenByDot[brokenByDot.length - 1];
    }
    const brokenBySlash = path.split("/");
    const name = brokenBySlash[brokenBySlash.length - 1];
    let folder = path.substring(0, path.lastIndexOf("/"));
    if (folder === "") {
        folder = defaultRoot;
    }
    brokenBySlash.shift();
    //console.log("before");
    const nameWithoutExtension = name.substring(0, name.length - extension.length);
    //console.log("after", nameWithoutExtension);
    const retPathParts = {
        fullPath: path,
        name,
        extension,
        nameWithoutExtension,
        folder,
        parts: brokenBySlash,
    };
    return retPathParts;
}
export function splitPathWithoutFirstElement(fullPath) {
    const firstElementRemovedFullPath = removeFirstPathElement(fullPath);
    if (firstElementRemovedFullPath === undefined) {
        return undefined;
    }
    return splitPath(firstElementRemovedFullPath);
}
export function removeFirstPathElement(fullPath) {
    const fullPathWithoutLeadingSlash = removeLeadingSlash(fullPath);
    const firstSlashIndex = fullPathWithoutLeadingSlash.indexOf("/");
    if (firstSlashIndex === -1) {
        return undefined;
    }
    return fullPathWithoutLeadingSlash.substring(firstSlashIndex);
}
/**
 * VÁLTOZÁS 2026-01-05 - Követelmény 2.4
 * Közös segédfüggvény a folder path normalizáláshoz
 * Biztosítja, hogy a FileUploadsModal, ExplorerComponent és worker
 * ugyanazt a folder path formátumot használja
 *
 * VÁLTOZÁS 2026-01-09 - Dani:
 * Visszavezettem a működést a meglévő alapfüggvényekre ahelyett, hogy újra megírnánk.
 *
 * @param filePath - A teljes fájl útvonal (pl. "/Uploaded/folder1/file.txt")
 * @param defaultRoot - Alapértelmezett gyökér, ha nincs folder (pl. "/Uploaded")
 * @returns Normalizált folder path leading slash-sel (pl. "/Uploaded/folder1")
 */
export function canonicalFolderPath(filePath, defaultRoot = "/") {
    if (!filePath)
        return defaultRoot;
    let normalized = filePath.replace(/\/+/g, "/");
    return splitPath(normalized, defaultRoot)?.folder || defaultRoot;
}
/**
 * Format seconds to HH:MM:SS format
 * @param totalSeconds - Total seconds to format
 * @returns Formatted time string (e.g., "01:23:45" or "23:45" if under 1 hour)
 */
export function formatTimeHHMMSS(totalSeconds) {
    const seconds = Math.floor(totalSeconds % 60);
    const minutes = Math.floor((totalSeconds / 60) % 60);
    const hours = Math.floor(totalSeconds / 3600);
    const pad = (n) => n.toString().padStart(2, '0');
    if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }
    return `${pad(minutes)}:${pad(seconds)}`;
}
